import { React, useState, useEffect } from "react";
import { AiTwotoneFolderOpen } from "react-icons/ai";
import { BiMessageRoundedDetail } from "react-icons/bi";
import { ImCancelCircle } from "react-icons/im";
import { MdCancel } from "react-icons/md";
import { MdCheckCircle } from "react-icons/md";
import Navbar from "../components/Navbar";
import axios from "axios";
import "./NotificationStyle.css";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const user = JSON.parse(localStorage.getItem("userInfo"));

  const PORT =
    "http://SkeleChaingang-env.eba-i65amzvv.us-west-2.elasticbeanstalk.com";
  // const PORT = 'http://femr-central-api.us-west-2.elasticbeanstalk.com';

  useEffect(() => {
    const fetchNotifcations = async () => {
      try {
        const response = await axios.get(`${PORT}/notifcations/${user.id}/`);
        return response.data;
      } catch (error) {
        console.warn(error);
        return false;
      }
    };

    if (Object.keys(notifications).length === 0) {
      fetchNotifcations().then((result) => {
        if (result) {
          setNotifications(result);
          setLoaded(true);
          console.log(notifications);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function deleteNotifcation(id) {
    try {
      const response = await axios.delete(`${PORT}/notifcation/${id}/`);
      console.log("notification need to be delete = ", response);
      console.log("status of the call = ", response.status);
      return response.status;
    } catch (error) {
      console.warn(error);
      return false;
    }
  }

  async function handleDeleteNotifcation(id) {
    const notiToBeDelete = await deleteNotifcation(id);
    if (notiToBeDelete === 204) {
      console.log("item removed");
      setNotifications(notifications.filter((noti) => noti.id !== id));
    } else {
      console.log("Error! Cannot remove item ", notiToBeDelete);
    }
  }

  function getIcon(type) {
    switch (type) {
      case "approved":
        return <MdCheckCircle size="80px" color="green" />;
      case "rejected":
        return <MdCancel size="80px" color="red" />;
      case "message":
        return <BiMessageRoundedDetail size="80px" />;
      case "completed":
        return <AiTwotoneFolderOpen size="80px" />;
      default:
        console.log("Error! Unmatch type.");
    }
  }

  const notifComponents =
    notifications.length !== 0 ? (
      notifications.map((notif) => (
        <div className="outer-box" key={notif.id}>
          <div
            className="cancel-box"
            onClick={() => {
              handleDeleteNotifcation(notif.id);
            }}
          >
            <ImCancelCircle size="23px" color="grey" />
          </div>
          <div className="noti-box">
            <div className="icon-box">{getIcon(notif.type)}</div>
            <div className="left-box">
              <p className="message">{notif.message}</p>
              <p className="date">{notif.date}</p>
            </div>
          </div>
        </div>
      ))
    ) : (
      <h3>- No Unread Notifications -</h3>
    );

  return (
    <div className="Notifications">
      <Navbar />
      <h1>Unread Notifications</h1>
      {loaded ? notifComponents : <h3>Loading ...</h3>}
    </div>
  );
};

export default Notifications;
